import { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Input from "../../../../../components/input/Input";
import { useWebsite } from "../Context/WebSiteContext";
import { Button } from 'primereact/button';

const GaleriaSite = ({ control, setValue, errors }) => {
  const { formData } = useWebsite();
  const [localImages, setLocalImages] = useState(
    (formData.galeria?.carouselImages || []).map(img =>
      typeof img === "string" ? { url: img } : img
    )
  );

  useEffect(() => {
    if (setValue) {
      setValue('galeria.carouselImages', localImages.map(img => img.url), { shouldDirty: true });
    }
  }, [localImages, setValue]);

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    
    const newImages = await Promise.all(
      files.map(file => 
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            resolve({
              file,
              url: reader.result 
            });
          };
        })
      )
    );
  
    setLocalImages(prev => [...prev, ...newImages]);
  };

  const handleRemoveImage = (index) => {
    setLocalImages(prev => {
      const newImages = prev.filter((_, i) => i !== index);
      URL.revokeObjectURL(prev[index].url);
      return newImages;
    });
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    
    const items = Array.from(localImages);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    setLocalImages(items);
  };

  useEffect(() => {
    return () => {
      localImages.forEach(image => URL.revokeObjectURL(image.url));
    };
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <Input
            label="Título do carrossel"
            control={control}
            name="galeria.Tittle_carrossel"
            className="form-control"
            rules={{ required: "Campo obrigatório" }}
          />
          {errors?.galeria?.Tittle_carrossel && (
            <span className="text-danger">Este campo é obrigatório</span>
          )}

          <div className="mt-4">
            <h4 className="text-center mb-4">
              Adicione imagens do empreendimento no seu carrossel:
            </h4>

            <div className="">
              <input 
                type="file"
                id="carousel-upload"
                accept="image/*"
                multiple
                onChange={(e) => {
                  e.preventDefault(); 
                  handleFileUpload(e);
                }}
                style={{ display: 'none' }}
              />
              <label 
                htmlFor="carousel-upload"
                className="p-button p-component p-button-outlined"
                style={{ cursor: 'pointer', display: 'inline-block', padding: '0.5rem 1rem' }}
              >
                <i className="pi pi-upload" style={{ marginRight: '0.5rem' }}></i>
                Clique para fazer upload
              </label>
            </div>

            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="carousel-images">
                {(provided) => (
                  <div 
                    ref={provided.innerRef} 
                    {...provided.droppableProps} 
                    className="mt-3"
                  >
                    {localImages.map((image, index) => (
                      <Draggable key={index} draggableId={String(index)} index={index}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="d-flex align-items-center p-2 border rounded mb-2 justify-content-between"
                            style={{ 
                              cursor: "grab", 
                              background: "#f8f9fa",
                              ...provided.draggableProps.style
                            }}
                          >
                            <img 
                              src={image.url} 
                              alt="Carrossel" 
                              style={{ width: 100, height: 70, marginRight: 10, objectFit: 'cover' }} 
                            />
                            <Button
                              type="button"
                              icon="pi pi-trash"
                              className="p-button-danger p-button-rounded p-button-sm"
                              onClick={() => handleRemoveImage(index)}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GaleriaSite;